//#region IMPORTS
//*REACT
import React from 'react';
//*ADDONS
import ReactDOM from 'react-dom/client';
//*COMPONENTS
import App from './App';
//#endregion

//#region ROOT
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
//#endregion
